export const LIMIT_OPERATIONS_ROUTE_PATHS = {
  limitOperations: '/fraud/limit-operations',
};
